export const MIME = {
    image: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/vnd.mozilla.apng",
        "image/x-png",
        "image/gif",
        "image/webp",
    ],
    audio: [
        "audio/vnd.wav",
        "audio/vnd.wave",
        "audio/wav",
        "audio/wave",
        "audio/x-pn-wav",
        "audio/x-wav",
        "audio/mpeg",
        "audio/mp3",
        "audio/mpeg3",
        "audio/x-mpeg-3",
        "audio/ogg",
        "audio/webm",
        "audio/mp4",
        "audio/m4a",
        "audio/mpeg4-generic",
        "audio/x-m4a",
    ],
    video: [
        "video/mp4",
        "video/mpeg",
        "video/webm",
        "video/x-msvideo",
        "video/quicktime",
    ],
    font: [
        "font/ttf",
        "application/x-font-ttf",
        "font/otf",
        "application/x-font-otf",
    ],
    caption: [
        "application/x-subrip",
    ],
}

export const EXTENSION = {
    image: [
        ".jfif",
        ".jfif-tbnl",
        ".jif",
        ".jpe",
        ".jpeg",
        ".jpg",
        ".pjpg",
        ".png",
        ".gif",
        ".webp",
    ],
    audio: [
        ".wav",
        ".m2a",
        ".m3a",
        ".mp2",
        ".mp2a",
        ".mp3",
        ".mpga",
        ".oga",
        ".ogg",
        ".spx",
        ".weba",
        ".3g2",
        ".3ga",
        ".3gp",
        ".3gp2",
        ".3gpa",
        ".3gpp",
        ".3gpp2",
        ".m4a",
        ".m4b",
        ".m4p",
        ".m4r",
        ".m4v",
        ".mp4",
        ".mp4v",
    ],
    video: [
        ".webm",
        ".mp4",
        ".mp4v",
        ".mpg4",
        ".m1v",
        ".m2v",
        ".mpa",
        ".mpe",
        ".mpeg",
        ".mpg",
        ".avi",
        ".mov",
        ".qt",
    ],
    font: [
        ".ttc",
        ".ttf",
        ".otf",
    ],
    caption: [
        ".srt",
    ],
}